const { Serializer } = require("jsonapi-serializer");

module.exports = {
  scheduleInterviewSerializer: (meta = {}) =>
    new Serializer("scheduleInterviewSerializer", {
      meta,
      pluralizeType: false,
      keyForAttribute: "snake_case",
      attributes: ["start_date", "end_date", "virtual", "place", "user_email", "user_ip"]
    })
};
